import { useEffect, useState } from "react";
import { BUSINESS } from "../site";

export default function NotFound() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col">
      {/* Navbar */}
      <nav className="bg-white shadow-sm px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="/" aria-label="Flip Ready home">
          <img
            src="/logo.webp"
            alt="Flip Ready Cleaning Services logo"
            width={96}
            height={56}
            className="h-14 w-auto"
          />
        </a>
        <a
          href={BUSINESS.phoneHref}
          className="hidden md:flex items-center gap-2 text-[#0b5b96] font-medium hover:text-[#084876] transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-phone-fill"></i>
          {BUSINESS.phoneDisplay}
        </a>
      </nav>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div
          className={`text-center max-w-2xl mx-auto transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {/* Big 404 with icon */}
          <div className="relative mb-8 inline-block">
            <span className="text-[10rem] md:text-[14rem] font-black text-[#0b5b96]/8 select-none leading-none block">
              404
            </span>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                <div className="w-20 h-20 flex items-center justify-center bg-[#0b5b96]/10 rounded-xl mx-auto mb-3">
                  <i className="ri-search-line text-[#0b5b96] text-4xl"></i>
                </div>
                <div className="flex items-center gap-2 justify-center">
                  <span className="w-2 h-2 rounded-full bg-[#5FA42B] inline-block"></span>
                  <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest">Page Not Found</span>
                  <span className="w-2 h-2 rounded-full bg-[#5FA42B] inline-block"></span>
                </div>
              </div>
            </div>
          </div>

          {/* Headline */}
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
            Looks like this page<br />
            <span className="text-[#0b5b96]">needs a clean sweep.</span>
          </h1>

          {/* Subtext */}
          <p className="text-gray-500 text-lg mb-10 leading-relaxed max-w-md mx-auto">
            We couldn&apos;t find the page you&apos;re looking for — it may have moved or never existed. Let&apos;s get you back on track.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href="/"
              className="bg-[#0b5b96] text-white px-8 py-3.5 rounded-full font-semibold hover:bg-[#084876] transition-all duration-200 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line"></i>
              Back to Homepage
            </a>
            <a
              href={BUSINESS.phoneHref}
              className="bg-white border border-gray-200 text-gray-700 px-8 py-3.5 rounded-full font-semibold hover:border-[#0b5b96] hover:text-[#0b5b96] transition-all duration-200 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              Call Us Directly
            </a>
          </div>

          {/* Quick Links */}
          <div className="border-t border-gray-200 pt-8">
            <p className="text-sm text-gray-400 font-medium uppercase tracking-wider mb-4">Or jump to a section</p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              {[
                { label: "Services", icon: "ri-service-line", anchor: "/#services" },
                { label: "Contact", icon: "ri-mail-send-line", anchor: "/#contact" },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.anchor}
                  className="flex items-center gap-1.5 bg-white border border-gray-200 text-gray-600 px-4 py-2 rounded-full text-sm font-medium hover:border-[#5FA42B] hover:text-[#0b5b96] transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className={link.icon}></i>
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </main>

      {/* Footer Strip */}
      <footer className="bg-white border-t border-gray-100 py-5 text-center">
        <p className="text-sm text-gray-400">
          &copy; {new Date().getFullYear()} Flip Ready Cleaning Services &mdash; Fredericksburg, VA &amp; Northern Virginia
        </p>
      </footer>
    </div>
  );
}
